/**
 * Product page Shop Pay installments message (shopify-payment-terms shadow DOM).
 */
(function () {
  var STYLE_ID = 'am-shop-pay-terms-style';
  var STYLE_CONTENT =
    ':host { color: #231F20; text-transform: uppercase; font-size: 10.5px; line-height: 1.2; }' +
    '#shopify-installments-content, #shopify-installments-content p, ' +
    '#shopify-installments-content span, #shopify-installments-content a, ' +
    '#shopify-installments-content div, #shopify-installments-content strong { ' +
    'color: #231F20 !important; text-transform: uppercase !important; ' +
    'font-size: 10.5px !important; line-height: 1.2 !important; }' +
    '#shopify-installments-content svg, #shopify-installments-content svg * { ' +
    'text-transform: none !important; }';

  function applyStyle(el) {
    if (!el || !el.shadowRoot) return false;
    if (el.shadowRoot.getElementById(STYLE_ID)) return true;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_CONTENT;
    el.shadowRoot.appendChild(style);
    return true;
  }

  function initPaymentTerms(scope) {
    var root = scope || document;
    root.querySelectorAll('.wt-product__payment-terms shopify-payment-terms').forEach(function (el) {
      if (applyStyle(el)) return;

      var observer = new MutationObserver(function () {
        if (applyStyle(el)) observer.disconnect();
      });
      observer.observe(el, { childList: true });
    });
  }

  function bindPaymentTermsContainers(scope) {
    var root = scope || document;
    root.querySelectorAll('.wt-product__payment-terms').forEach(function (container) {
      initPaymentTerms(container);
      if (container.dataset.amPaymentTermsBound === 'true') return;
      container.dataset.amPaymentTermsBound = 'true';

      var observer = new MutationObserver(function () {
        initPaymentTerms(container);
      });
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindPaymentTermsContainers();
    });
  } else {
    bindPaymentTermsContainers();
  }

  document.addEventListener('shopify:section:load', function (e) {
    bindPaymentTermsContainers(e.target);
  });
})();
